// youtube enabling
let enableYoutubeElems = document.getElementsByClassName('enableYoutube');
Array.prototype.forEach.call(enableYoutubeElems, function (el, i) {
    el.addEventListener('click', (event) => {
        event.preventDefault();
        localStorage.setItem("youtubeEnabled", "true");
        loadYoutubeScript();
    });
});
if(localStorage.getItem("youtubeEnabled") === "true") {
    loadYoutubeScript();
}

function localStorageCleanup() {
    localStorage.removeItem("youtubeEnabled");
    alert('Das automatische Laden von YouTube Videos wurde deaktiviert.')
}

function loadYoutubeScript() {
    let youtubeContainerElems = document.getElementsByClassName('youtubeContainer');
    Array.prototype.forEach.call(youtubeContainerElems, function (el, i) {
        el.classList.add('enabled');
        let currentIframeContainer = el.querySelectorAll('.iFrameContainer')[0];
        let iframeHtml = currentIframeContainer.innerHTML.replace('<!--', '').replace('-->', '');
        el.innerHTML += iframeHtml;
    });
}
